@if (showLoadingSpinner$ | async) {
  <div class="modal-background">
    <app-generic-spinner data-testid="loading-spinner"></app-generic-spinner>
  </div>
}
